/* Gestaffeltes Einblenden von Kacheln/Karten beim Scrollen (Premium-Pass
   09/2026). Progressive Enhancement: ohne JS/IntersectionObserver oder bei
   prefers-reduced-motion bleibt alles sofort sichtbar. Im Theme-Editor aus.
   Bewusst NICHT auf Konfigurator und Hero (eigene Choreografie, Galerie-
   Slides arbeiten mit opacity). Nach dem Einblenden entfernt sich die
   Klasse wieder, damit Hover-Transitions der Kacheln nicht ausgebremst
   werden. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const SELECTORS = [
    '.cs-steps__tile', '.cs-places__tile', '.cs-guides__tile', '.cs-about__card',
    '.cs-scope a.cs-hub__tile', '.cs-scope a.cs-series__card', '.cs-scope a.cs-blog__card',
    '.cs-lc__stage', '.cs-b2b__card', '.cs-faq__item', '.cs-article__card'
  ];

  const init = () => {
    const els = [...document.querySelectorAll(SELECTORS.join(','))]
      .filter((el) => !el.classList.contains('cs-reveal') && !el.dataset.csRevealed);
    if (!els.length) return;

    /* Stagger je Geschwistergruppe: Kacheln eines Rasters laufen 70ms versetzt. */
    const groups = new Map();
    els.forEach((el) => {
      const parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach((list) => list.forEach((el, i) => {
      el.classList.add('cs-reveal');
      el.style.setProperty('--cs-reveal-i', String(Math.min(i, 7)));
    }));

    const finish = (el) => {
      el.classList.remove('cs-reveal', 'is-in');
      el.style.removeProperty('--cs-reveal-i');
      el.dataset.csRevealed = '1';
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        el.classList.add('is-in');
        const t = setTimeout(() => finish(el), 1400);
        el.addEventListener('transitionend', () => { clearTimeout(t); finish(el); }, { once: true });
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    els.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
